import React, { createContext, useState } from 'react';
import { Notification } from '@wix/design-system';
import type { NotificationTheme } from '@wix/design-system/dist/types/Notification';
import css from './NotificationsContext.scss';

export interface ShowToastProps {
  message: string;
  theme: NotificationTheme;
}

export const NotificationsContext = createContext({
  showToast: (notification: ShowToastProps) => {},
});

const notificationAutoHideTime = 8000;
export const NotificationsProvider = ({ children }) => {
  const [showNotification, setShowNotification] =
    useState<ShowToastProps | null>(null);
  const showToast = (notification: ShowToastProps) => {
    setShowNotification(notification);
    setTimeout(() => setShowNotification(null), notificationAutoHideTime);
  };
  return (
    <NotificationsContext.Provider value={{ showToast }}>
      <div className={css.notification}>
        <Notification
          dataHook="toast-notification-over-docs"
          show={!!showNotification}
          autoHideTimeout={notificationAutoHideTime}
          type="local"
          zIndex={9999999}
          theme={showNotification?.theme}
        >
          <Notification.TextLabel>
            {showNotification?.message}
          </Notification.TextLabel>
        </Notification>
      </div>
      {children}
    </NotificationsContext.Provider>
  );
};
